// extracted by mini-css-extract-plugin
export default {"avatar":"style_avatar__f5cAp","avatarsmall":"style_avatarsmall__a0TCJ"};